export default "__VITE_ASSET__G4UDYNJz__"